import { gql } from '@apollo/client'

export const GET_TASKS_PAGINATED = gql`
  query TasksPaginated($payload: TasksPayload) {
    tasksPaginated(payload: $payload) {
      count
      tasks {
        id
        title
        description
        due_on
        priority
        is_complete
        completed_at
        action_type {
          id
          name
        }
        task_users {
          id
          user {
            id
            first_name
            last_name
            profile_image_url
          }
        }
        task_people {
          id
          person {
            id
            first_name
            last_name
          }
        }
        task_properties {
          id
          property {
            id
            name
          }
        }
        task_units {
          id
          unit {
            id
            name
          }
        }
        task_activities {
          id
          type
          created_by_id
          created_at
        }
        sub_tasks {
          id
          title
          description
          due_on
          priority
          is_complete
          completed_at
          action_type {
            id
            name
          }
          task_users {
            id
            user {
              id
              first_name
              last_name
              profile_image_url
            }
          }
        }
      }
    }
  }
`

export const GET_TASK_USERS = gql`
  query TaskUsers {
    users {
      id
      first_name
      last_name
    }
  }
`

export const GET_TASK_TYPES = gql`
  query TaskTypes {
    taskTypes {
      id
      name
    }
  }
`

export const GET_TASK_PERSON = gql`
  query GetTaskPerson($id: Int!) {
    person(id: $id) {
      id
      type
      unit_occupancy_tenants {
        id
        unit_occupancy {
          id
          created_at
          unit {
            id
          }
        }
      }
      person_properties {
        id
        property {
          id
          name
        }
      }
    }
  }
`
